import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  SpokeAdminsField,
  SpokeAdminsFieldValue,
  spokeAdminsErrors,
} from './SpokeAdminsField';

export const SpokeAdminsFieldExtension = FormFieldBlueprint.make({
  name: 'spoke-admins-field',
  params: {
    field: async () =>
      createFormField({
        name: 'SpokeAdminsField',
        component: SpokeAdminsField,
        validation: (value: SpokeAdminsFieldValue | undefined, validation) => {
          for (const error of spokeAdminsErrors(value)) {
            validation.addError(error);
          }
        },
      }),
  },
});
